module.exports = __webpack_public_path__ + "img/676383437.28a8c3f2.jpg";